import { createSlice } from '@reduxjs/toolkit';

import {
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
} from '../request-failed/reducer';
import {
  type IProductWatchdogState,
  type IWatchdogRegister,
  type IWatchdogRegisterResponse,
} from './types';

const initialState: IProductWatchdogState = {
  isLoading: false,
  registered: null,
};

const productWatchdogSlice = createSlice({
  name: 'ProductWatchdog',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    watchdogRegister: (state, _action: IWatchdogRegister): void => {
      state.isLoading = true;
      state.registered = null;
    },
    watchdogRegisterResponse: (
      state,
      action: IWatchdogRegisterResponse,
    ): void => {
      state.isLoading = false;
      state.registered = action.payload.registered;
    },
    watchdogReset: (state): void => {
      state.isLoading = false;
      state.registered = null;
    },
  },
  extraReducers: (builder): void => {
    builder.addMatcher(
      requestFailedMatcher('ProductWatchdog'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const { watchdogRegister, watchdogRegisterResponse, watchdogReset } =
  productWatchdogSlice.actions;

export default productWatchdogSlice.reducer;
